import RelationshipsMappingPageReducer from './RelationshipsMappingPageReducer';
import { ProfileRelationshipsListReducers } from './containers/ProfileRelationshipsList';

export default from './RelationshipsMappingPageContainer';
export const RelationshipsMappingPageReducers = {
  ProfileRelationshipsMappingPageReducer: RelationshipsMappingPageReducer,
  ...ProfileRelationshipsListReducers,
};
